import { render } from "./BaseDemandCard.component.vue?vue&type=template&id=5151bd5a&scoped=true"
import script from "./BaseDemandCard.component.vue?vue&type=script&lang=js"
export * from "./BaseDemandCard.component.vue?vue&type=script&lang=js"

import "./BaseDemandCard.component.vue?vue&type=style&index=0&id=5151bd5a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5151bd5a"]])

export default __exports__